<template>
  <div class="main-page">
    <Menu
      title="评价信息"
      :home="true"
    />
    <div class="container-flex">
      ddd
    </div>
  </div>
</template>

<script>
import Menu from '../../components/Menu'
export default {
  components: {
    Menu
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="stylus" scoped></style>
